var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBik(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 24,
    viewBox: "0 0 104 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_30_755)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 24H0V8L12 0L24 8V24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.64 13C49.38 12 47.42 11.43 44.76 11.43H38V8.49H51.13V4H32V24H44.72C47.3867 24 49.35 23.43 50.61 22.29C51.263 21.6818 51.7743 20.9374 52.1079 20.1097C52.4414 19.282 52.5889 18.3911 52.54 17.5C52.589 16.6545 52.4432 15.8091 52.1138 15.0288C51.7844 14.2486 51.2801 13.5545 50.64 13ZM45.82 19.51C45.0634 20.0243 44.1507 20.2578 43.24 20.17H38V15H43.25C44.1669 14.9075 45.0856 15.1568 45.83 15.7C46.0802 15.9446 46.2755 16.2396 46.4031 16.5655C46.5307 16.8913 46.5876 17.2405 46.57 17.59C46.592 17.9453 46.5363 18.3011 46.4067 18.6327C46.2772 18.9643 46.077 19.2637 45.82 19.51Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3502 15.61C61.1802 15.84 61.0602 16.01 60.9802 16.14L60.7802 16.47H60.7202V4H54.7202V24H61.2602L70.0002 12.2C70.1702 11.96 70.2902 11.77 70.3702 11.64L70.5802 11.24V11.62C70.5802 11.74 70.5802 11.95 70.5802 12.26V24H76.5802V4H70.0002L61.3502 15.61Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.1102 24H104L93.3902 13.42L103.26 4H95.6802L88.0902 11.35H85.9402V4H79.9502V24H85.9402V16.17H88.1902L96.1102 24Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_30_755"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBik);
export default __webpack_public_path__ + "static/media/BIK.e3d397a34f7967aa14166978b5e82835.svg";
export { ForwardRef as ReactComponent };